export const FeatureSections = [
  {
    title: "What you see is what you play",
    description:
      "Hundreds of shells, cakes, racks, firecrackers, guns, planes, helicopters, torches and props — laid out right in front of you. Pick anything up and light it. No coins, no tickets, no loot boxes.",
    images: [
      "/images/webp/what-you-see.webp",
      "/images/webp/what-you-see-fireworks.webp",
      "/images/webp/what-you-see-beach.webp",
      "/images/webp/what-you-see-street.webp",
      "/images/webp/what-you-see-street-burst.webp",
    ],
    alt: "3D scene showing the full Fireworks Play item arsenal on a city street",

  },
  {
    title: "Every type of firework is available here!",
    description:
      "Shells, cakes, fountains, mines, comets, firecrackers and racks — the whole catalog is unlocked from the start. Light a whole street at once and paint the night sky.",
    images: [
      "/images/webp/every-firework.webp",
      "/images/webp/every-firework-city.webp",
      "/images/webp/every-firework-stadium-purple.webp",
      "/images/webp/every-firework-stadium-gold.webp",
      "/images/webp/every-firework-stadium-green.webp",
    ],
    alt: "Stadium fireworks show with colorful smoke, laser beams and giant shell bursts",
  },
  {
    title: "Plenty of maps to choose",
    description:
      "Downtown streets, wild-west towns, samurai villages, horror mansions and more. Pick a new playground every time you play.",
    images: [
      "/images/webp/map-big-city.webp",
      "/images/webp/map-stadium.webp",
      "/images/webp/map-west.webp",
      "/images/webp/map-mountain-city.webp",
      "/images/webp/map-steampunk.webp",
    ],
    alt: "Big City, Stadium, West, Mountain City and Steampunk maps from the game",
  },
  {
    title: "Masterpiece of pyrotechnics",
    description:
      "Brocade, Chrysanthemum, Crossette, Dahlia, Willow, Strobe, Salute and more. Tune colors, heights, timing, trails, sizes, angles and sounds — even draw hearts and shapes in the sky.",
    image: "/images/webp/masterpiece.webp",
    alt: "Colorful fireworks bursting over a samurai village at night",
  },
  {
    title: "Seasonal maps to match every vibe",
    description:
      "Snowy towns, holiday decorations, hot-air balloons and lanterns. Celebrate Christmas, New Year, Halloween or summer nights with a map that fits the mood.",
    images: [
      "/images/webp/seasonal-maps-christmas.webp",
      "/images/webp/seasonal-maps-lantern-festival.webp",
      "/images/webp/seasonal-maps-winter.webp",
      "/images/webp/seasonal-maps-halloween.webp",
    ],
    alt: "Seasonal maps with Christmas decorations, sky lanterns, a snowy night and glowing Halloween pumpkins",
  },
  {
    title: "Ammunition and explosives for destruction",
    description:
      "Gas tanks, grenades, TNT, powder and nukes. Blow things up, demolish buildings and turn any map into your personal demolition range.",
    images: [
      "/images/webp/ammunition-arsenal.webp",
      "/images/webp/ammunition-desert-blast.webp",
      "/images/webp/ammunition-burning-town.webp",
    ],
    alt: "Gas tanks, TNT crates and grenades in a wild-west town",
  },
  {
    title: "Multiplayer",
    description:
      "Team up with friends in real time to choreograph epic shows — or compete and cause explosive chaos. Watch out: lighting TNT or gas tanks might blast your pals.",
    images: [
      "/images/webp/multiplayer-city.webp",
      "/images/webp/multiplayer-firefight.webp",
      "/images/webp/multiplayer-fireworks.webp",
    ],
    alt: "First-person view of a multiplayer session on a city street at night",
  },
  {
    title: "Mini-games, maximum entertainment",
    description:
      "Football face-offs, quick-draw duels, nuke-crafting puzzles, horror-mansion break-ins, hot-air-balloon flights, helicopter missions and clay hunts.",
    images: [
      "/images/webp/mini-games.webp",
      "/images/webp/mini-games-hammer.webp",
      "/images/webp/mini-games-key.webp",
    ],
    alt: "Nuke-crafting puzzle mini-game on a farm",
  },
  {
    title: "Custom maps",
    description:
      "Set up your own playgrounds the way you like — arrange gear, save your setups and load them back anytime for the perfect show.",
    images: [
      "/images/webp/custom-maps-mega-mall.webp",
      "/images/webp/custom-maps-concert-stage.webp",
    ],
    alt: "Community custom maps including a Mega Mall and a concert stage built by players",
  },
  {
    title: "Custom fireworks",
    description:
      "Design your own unique fireworks from scratch — mix colors, shapes, trails and timing to create one-of-a-kind shells that no one else has.",
    images: [
      "/images/webp/custom-fireworks-editor.webp",
      "/images/webp/custom-fireworks-preview.webp",
    ],
    alt: "Custom firework editor with shell tail effect settings and a golden firework preview",
  },
  {
    title: "Community shows",
    description:
      "Save, load and publish your creations to the community. Play someone else's masterpiece on your map and join events on Discord.",
    images: [
      "/images/webp/community-shows-red-canyon.webp",
      "/images/webp/community-shows-green-valley.webp",
      "/images/webp/community-shows-stadium-red.webp",
      "/images/webp/community-shows-tower-green.webp",
      "/images/webp/community-shows-stadium-burst.webp",
      "/images/webp/community-shows-stadium-gold.webp",
    ],
    alt: "Community firework shows lighting up a red canyon and a green valley",
  },
];
